// A sync action that refuses is answered with HTTP 500 and the action's own result as the body, so `execute`
// rejects with it. Callers that render the server's reason need that result back rather than a thrown error.
export async function resolveActionRefusal<T>(pending: Promise<T>): Promise<T> {
    try {
        return await pending;
    } catch (error) {
        if (isActionRefusal(error)) {
            return error as T;
        }
        throw error;
    }
}

function isActionRefusal(error: unknown): boolean {
    if (typeof error !== "object" || error === null) {
        return false;
    }
    const body = error as { success?: unknown; payload?: unknown };
    return body.success === false && typeof body.payload === "object" && body.payload !== null;
}
